/**
 * Brand-name accessor.
 *
 * Reads `REACT_APP_BRAND_NAME` at build time (set in `.env` / docker build args)
 * and falls back to `"Orgain"` when unset. Used wherever the product/company
 * name appears in user-facing copy (titles, headers, footers, alt text, etc.).
 */
export const BRAND_NAME: string = (process.env.REACT_APP_BRAND_NAME || 'Orgain').trim() || 'Orgain';

/**
 * Default Frappe `Orgain Company` document id (the DB primary key).
 *
 * Reads `REACT_APP_DEFAULT_COMPANY_ID` at build time and falls back to
 * `"Orgain"`. Kept separate from `BRAND_NAME` because the UI label and the
 * underlying Frappe doc name can legitimately differ (e.g. a tenant rebrands
 * to "Acme" while the Frappe doc is still named "Orgain").
 */
export const DEFAULT_COMPANY_ID: string =
  (process.env.REACT_APP_DEFAULT_COMPANY_ID || 'Orgain').trim() || 'Orgain';

export const BRANDING_CHANGED_EVENT = 'orgain:branding-changed';

export const notifyBrandingChanged = (): void => {
  window.dispatchEvent(new Event(BRANDING_CHANGED_EVENT));
};

const BRAND_LOGO_CACHE_KEY = 'orgain:brand-logo-url';

export const getCachedBrandLogo = (): string | null => {
  try {
    return localStorage.getItem(BRAND_LOGO_CACHE_KEY) || null;
  } catch {
    return null; // private mode / storage disabled - just skip the cache
  }
};

export const setCachedBrandLogo = (url: string | null): void => {
  try {
    if (url) localStorage.setItem(BRAND_LOGO_CACHE_KEY, url);
    else localStorage.removeItem(BRAND_LOGO_CACHE_KEY);
  } catch {
    /* ignore - caching is best-effort */
  }
};
